import { useNavigate } from "react-router-dom";
import useGetTableIndex from "../../../../../../core/hooks/layout/useGetTableIndex";
import TableLayout from "../../../../../layout/main/TableLayout";
import { Column, DText, Relative, Row } from "../../../../../../styles/CommonStyles";
import { TradeTypeBadge } from "../../../../../../styles/main/orders";
import DateTime from "../../../../../common/utils/DateTime";
import Operation from "../../../../../common/utils/Operation";
import { userCardHistoryAttributes } from "../../../../../../core/constants/headers";
import { formatNumber } from "../../../../../../core/utils/common";

const UserCardHistoryTable = ({ data }) => {

    const { data: userCards } = data;
    const { cs, headers } = userCardHistoryAttributes;
    const { getTableIndex } = useGetTableIndex();
    const navigate = useNavigate();

    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
        >
            {userCards?.data?.map((transaction, idx) => (
                <Relative key={transaction.id}>
                    <Row
                        key={transaction.id}
                        cs={cs}
                        index={idx}
                    >

                        <Column>
                            {getTableIndex(idx)}
                        </Column>

                        <Column>
                            <DText main fontSize="s">
                                {transaction.transactionDisplayId}
                            </DText>
                        </Column>

                        <Column>
                            <DText
                                main
                                fontSize="s"
                                style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {transaction.detail}
                            </DText>
                        </Column>

                        <Column>
                            <TradeTypeBadge color="primary">
                                {transaction.type}
                            </TradeTypeBadge>
                        </Column>

                        <Column>
                            <DText main fontSize="s">
                                {formatNumber(transaction.amount)}{" "}
                                {transaction.transactionCurrency}
                            </DText>
                        </Column>

                        <Column>
                            <DText main fontSize="s">
                                {formatNumber(transaction.fee)}
                            </DText>
                        </Column>

                        <Column>
                            <TradeTypeBadge
                                color={
                                    transaction.status === "CLOSED"
                                        ? "success"
                                        : transaction.status === "PENDING"
                                            ? "warning"
                                            : "danger"
                                }
                            >
                                {transaction.status}
                            </TradeTypeBadge>
                        </Column>

                        <Column center>
                            <DateTime dt={Number(transaction.createTime)} />
                        </Column>

                    </Row>
                </Relative>
            ))}
        </TableLayout>
    );
};

export default UserCardHistoryTable;